@switch (type) {
@case (SurveyRequestType.Field_Survey) {
{{"manageSurveys.fieldSurvey" | translate}}
}
@case (SurveyRequestType.Opinion_Poll) {
{{"manageSurveys.opinionPoll" | translate}}
}
}